module.exports = __webpack_public_path__ + "img/delete_grey.ef3a35ce.svg";